<!-- VISION Info component -->
<template>
  <md-card id="vision" class="md-with-hover" @mouseover.native.once="mouseOver">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="card-icon"><md-icon>assignment</md-icon></div>
      <h4 class="title" style="font-weight: 400;">VA, IOP, Ant Seg OCT</h4>
    </md-card-header>

    <md-card-content>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">&nbsp;</div>
        <div class="md-layout-item md-caption md-size-20" style="font-weight:bold;">OD</div>
        <div class="md-layout-item md-caption md-size-20" style="font-weight:bold;">OS</div>
      </div>
      <hr />

      <div class="md-layout md-gutter">
        <label class="md-layout-item">&nbsp;</label>
      </div>

      <!--ACUITY DISTANCE -->
      <div class="md-layout md-gutter">
        <label class="md-layout-item lbl1" align="Right">Visual Acuity</label>
        <label class="md-layout-item lbl2" align="Right"
          >Distance (<b>{{ visionInfo.acuityWCorrectionD }}</b
          >):</label
        >
        <div class="md-layout-item" align="Center">
          <md-field class="field"> {{ visionInfo.acuityDistanceOD }}</md-field>
        </div>
        <div class="md-layout-item" align="Center">
          <md-field class="field"> {{ visionInfo.acuityDistanceOS }}</md-field>
        </div>
      </div>

      <!--ACUITY NEAR -->
      <div class="md-layout md-gutter">
        <label class="md-layout-item" align="Right" style="font-size:.70rem; " />
        <label class="md-layout-item lbl2" align="Right"
          >Near (<b>{{ visionInfo.acuityWCorrectionN }}</b
          >):</label
        >
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ visionInfo.acuityNearOD }}</md-field>
        </div>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ visionInfo.acuityNearOS }}</md-field>
        </div>
      </div>

      <!--COLOR PERCEPTION -->
      <!--
      <div class="md-layout md-gutter">
        <label class="md-layout-item" align="Right" style="font-size:.70rem; " />
        <label class="md-layout-item lbl2" align="Right">Color:</label>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ colorOD }}</md-field>
        </div>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ colorOS }}</md-field>
        </div>
      </div>
    -->
      <!--DEPTH PERCEPTION -->
      <!--
      <div class="md-layout md-gutter">
        <label class="md-layout-item" align="Right" style="font-size:.70rem; " />
        <label class="md-layout-item lbl2" align="Right">Stereo (Binocular):</label>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ depthOU }}</md-field>
        </div>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ depthOU }}</md-field>
        </div>
      </div>
      -->

      <hr
        style="width: 100%; border: 1px solid #4269a7; text-align: right; margin-right: 0px; margin-top:20px; margin-bottom: 15px;"
      />

      <!--AUTO REFRACTION -->
      <div class="md-layout md-gutter">
        <label class="md-layout-item lbl1" align="Right">Auto Refraction</label>
        <label class="md-layout-item lbl2" align="Right">&nbsp;</label>

        <div class="md-layout-item md-size-50" align="Left">
          <div class="md-layout" align="Left">
            <div class="md-layout md-layout-item md-size-50" align="Left" style="padding-top: 10px;">
              <div class="md-layout-item md-size-33 label"><u>Sph</u></div>
              <div class="md-layout-item md-size-33 label"><u>Cyl</u></div>
              <div class="md-layout-item md-size-33 label"><u>Ax</u></div>
            </div>

            <!--<div class="md-layout md-layout-item md-size-5">&nbsp;</div>-->

            <div class="md-layout md-layout-item md-size-50" align="Left" style="padding-top: 10px;">
              <div class="md-layout-item md-size-33 label"><u>Sph</u></div>
              <div class="md-layout-item md-size-33 label"><u>Cyl</u></div>
              <div class="md-layout-item md-size-33 label"><u>Ax</u></div>
            </div>
          </div>
        </div>
      </div>

      <div class="md-layout md-gutter">
        <label class="md-layout-item lbl1" align="Right" style="margin-top:0px;" />
        <label class="md-layout-item lbl2" align="Right" style="margin-top:0px;">&nbsp;</label>

        <div class="md-layout-item md-size-50">
          <div class="md-layout">
            <div class="md-layout md-layout-item md-size-50">
              <div class="md-layout-item md-size-33 field2">{{ OD_Sph }}</div>
              <div class="md-layout-item md-size-33 field2">{{ OD_Cyl }}</div>
              <div class="md-layout-item md-size-33 field2">{{ OD_Axis }}</div>
              <div class="md-layout-item" />
            </div>

            <!--<div class="md-layout md-layout-item md-size-5">&nbsp;</div>-->

            <div class="md-layout md-layout-item md-size-50">
              <div class="md-layout-item md-size-33 field2">{{ OS_Sph }}</div>
              <div class="md-layout-item md-size-33 field2">{{ OS_Cyl }}</div>
              <div class="md-layout-item md-size-33 field2">{{ OS_Axis }}</div>
            </div>
          </div>
        </div>
      </div>

      <hr
        style="width: 100%; border: 1px solid #4269a7; text-align: right; margin-right: 0px; margin-top:30px; margin-bottom: 15px;"
      />

      <!--Anterior Segment OCT-->
      <div class="md-layout md-gutter">
        <label class="md-layout-item lbl1" align="Right">Anterior Segmnent</label>
        <label class="md-layout-item lbl2" align="Right">Angle:</label>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ OD_Angle }}</md-field>
        </div>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ OS_Angle }}</md-field>
        </div>
      </div>

      <div class="md-layout md-gutter">
        <label class="md-layout-item" align="Right">&nbsp;</label>
        <label class="md-layout-item lbl2" align="Right">Thickness:</label>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ visionInfo.anteriorThicknessOD }}</md-field>
        </div>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ visionInfo.anteriorThicknessOS }}</md-field>
        </div>
      </div>

      <div class="md-layout md-gutter">
        <label class="md-layout-item" align="Right">&nbsp;</label>
        <label class="md-layout-item lbl2" align="Right"
          >Pupillary Distance: <span class="lbl1">{{ pupillaryDistanceAGG }}</span></label
        >
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ pupillaryDistance_OD }}</md-field>
        </div>
        <div class="md-layout-item" align="Center">
          <md-field class="field">{{ pupillaryDistance_OS }}</md-field>
        </div>
      </div>

      <hr
        style="width: 100%; border: 1px solid #4269a7; text-align: right; margin-right: 0px; margin-top:20px; margin-bottom: 15px;"
      />

      <!--EYE PRESSURE -->
      <div class="md-layout md-gutter">
        <label class="md-layout-item lbl1" align="Right">Intra Ocular Pressure</label>
        <label class="md-layout-item lbl2" align="Right">Eye Pressure:</label>
        <div class="md-layout-item md-size-25">
          <md-field class="field" :style="ohtnIOP_OD ? 'color: red' : ''"> {{ visionInfo.eyePressureOD }}</md-field>
        </div>
        <div class="md-layout-item md-size-25">
          <md-field class="field" :style="ohtnIOP_OS ? 'color: red' : ''"> {{ visionInfo.eyePressureOS }}</md-field>
        </div>
      </div>
      <!--Corrected EYE PRESSURE -->
      <div class="md-layout md-gutter">
        <label class="md-layout-item lbl1" align="Right"> </label>
        <label class="md-layout-item lbl2" align="Right">Corrected IOP:</label>
        <div class="md-layout-item md-size-25">
          <md-field class="field" :style="ohtnCIOP_OD ? 'color: red' : ''"> {{ correctedIOP_OD }}</md-field>
        </div>
        <div class="md-layout-item md-size-25">
          <md-field class="field" :style="ohtnCIOP_OS ? 'color: red' : ''"> {{ correctedIOP_OS }}</md-field>
        </div>
      </div>
    </md-card-content>

    <hr style="width: 95%; border-bottom: 2px;" />
  </md-card>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: "InfoVision",
  data() {
    return {
      elevated_IOP: 22
    }
  },
  computed: {
    ...mapGetters(["visionInfo"]),

    OD_Angle() {
      if (this.visionInfo.angleMeasurementOD.includes("None")) {
        return "n/a"
      }
      return this.visionInfo.angleMeasurementOD //.replaceAll("°", "<sup>o</sup>")
    },
    OS_Angle() {
      if (this.visionInfo.angleMeasurementOS.includes("None")) {
        return "n/a"
      }
      return this.visionInfo.angleMeasurementOS //.replaceAll("°", "<sup>o</sup>")
    },

    pupillaryDistance_OD() {
      return this.visionInfo.visionComments.split("|")[3] ? this.visionInfo.visionComments.split("|")[3] : "n/a"
    },
    pupillaryDistance_OS() {
      return this.visionInfo.visionComments.split("|")[4] ? this.visionInfo.visionComments.split("|")[4] : "n/a"
    },
    pupillaryDistanceAGG() {
      if (this.pupillaryDistance_OD != "n/a" && this.pupillaryDistance_OS != "n/a") {
        return "[" + Math.round(Number(this.pupillaryDistance_OD) + Number(this.pupillaryDistance_OS)) + "]"
      } else {
        return ""
      }
    },
    ohtnIOP_OD() {
      if (Number(this.visionInfo.eyePressureOD) >= this.elevated_IOP) return true
    },
    ohtnIOP_OS() {
      if (Number(this.visionInfo.eyePressureOS) >= this.elevated_IOP) return true
    },
    ohtnCIOP_OD() {
      if (Number(this.correctedIOP_OD) >= this.elevated_IOP) return true
    },
    ohtnCIOP_OS() {
      if (Number(this.correctedIOP_OS) >= this.elevated_IOP) return true
    },

    viOD() {
      return this.visionInfo.autoRefractionOD
    },
    viOS() {
      return this.visionInfo.autoRefractionOS
    },
    colorOD() {
      if (this.visionInfo.visionComments) {
        var colR = this.visionInfo.visionComments.split("|")[0]
        return colR
      }
    },
    colorOS() {
      if (this.visionInfo.visionComments) {
        var colL = this.visionInfo.visionComments.split("|")[1]
        return colL
      }
    },
    depthOU() {
      if (this.visionInfo.visionComments) {
        var stereo = this.visionInfo.visionComments.split("|")[2]
        return stereo
      }
    },

    OD_Sph() {
      if (this.viOD) {
        var ods = this.viOD.slice(0, this.viOD.indexOf(" "))
        return ods
      } else {
        return "n/a"
      }
    },
    OD_Cyl() {
      if (this.viOD) {
        var odc = this.viOD.slice(this.viOD.indexOf(" "), this.viOD.indexOf("x"))
        return odc
      } else {
        return "n/a"
      }
    },
    OD_Axis() {
      if (this.viOD) {
        var oda = this.viOD.slice(this.viOD.indexOf("x") + 1)
        return oda
      } else {
        return "n/a"
      }
    },

    OS_Sph() {
      if (this.viOS) {
        var ods = this.viOS.slice(0, this.viOS.indexOf(" "))
        return ods
      } else {
        return "n/a"
      }
    },
    OS_Cyl() {
      if (this.viOS) {
        var odc = this.viOS.slice(this.viOS.indexOf(" "), this.viOS.indexOf("x"))
        return odc
      } else {
        return "n/a"
      }
    },
    OS_Axis() {
      if (this.viOS) {
        var oda = this.viOS.slice(this.viOS.indexOf("x") + 1)
        return oda
      } else {
        return "n/a"
      }
    },
    correctedIOP_OD() {
      const pressure = this.visionInfo.eyePressureOD;
      const thickness = this.visionInfo.anteriorThicknessOD;

      // Corrected IOP = Measured IOP - ((CCT - 545) / 50) * 2.5
      const correctionFactor = ((thickness - 545) / 50) * 2.5;
      const correctedPressure = pressure - correctionFactor;

      // Whole numbers pls
      return Math.round(correctedPressure);
    },
    correctedIOP_OS() {
      const pressure = this.visionInfo.eyePressureOS;
      const thickness = this.visionInfo.anteriorThicknessOS;

      const correctionFactor = ((thickness - 545) / 50) * 2.5;
      const correctedPressure = pressure - correctionFactor;

      return Math.round(correctedPressure);
    }
  },
  mounted: function() {
    this.visionInfo.findingsOD = []
    this.visionInfo.findingsOS = []
    this.visionInfo.findingsOU = []
    this.visionInfo.diagnosesOD = []
    this.visionInfo.diagnosesOS = []
    this.visionInfo.diagnosesOU = []
    this.visionInfo.recommendOD = []
    this.visionInfo.recommendOS = []
    this.visionInfo.recommendOU = []

    this.OHTN_OD()
    this.OHTN_OS()
    this.OHTN_OU()
  },
  methods: {
    mouseOver: function() {
      try {
        this.OHTN_OD()
        this.OHTN_OS()
        this.OHTN_OU()
        this.$store.dispatch("loadSummary", null)
      } catch (error) {}
    },
    // Highly suspect all this OHTN code is depreciated
    OHTN_OD() {
      if ((this.ohtnIOP_OD || this.ohtnCIOP_OD) && !(this.ohtnIOP_OS || this.ohtnCIOP_OS)) {
      this.updateFinding_OD(
      "OHTN",
      "Ocular Hypertension of Right Eye (H40.051), ",
      "The intraocular pressure is elevated. Recommend further evaluation in office."
      )
      }
    },
    OHTN_OS() {
      if ((this.ohtnIOP_OS || this.ohtnCIOP_OS) && !(this.ohtnIOP_OD || this.ohtnCIOP_OD)) {
        this.updateFinding_OS(
        "OHTN",
        "Ocular Hypertension of Left Eye (H40.052), ",
        "The intraocular pressure is elevated. Recommend further evaluation in office."
        )
      }
    },
    OHTN_OU() {
      if ((this.ohtnIOP_OS || this.ohtnCIOP_OS) && (this.ohtnIOP_OD || this.ohtnCIOP_OD)) {
      this.updateFinding_OU(
        "OHTN",
        "Ocular Hypertension, bilateral (H40.053), ",
        "The intraocular pressure is elevated in both eyes. Recommend further evaluation in office."
        )
      }
    },
    updateFinding_OD(f, d, r) {
      this.visionInfo.findingsOD.push(f)
      this.visionInfo.diagnosesOD.push(d)
      this.visionInfo.recommendOD.push(r)
      console.log("OD_VIS_F: " + this.visionInfo.findingsOD[0])
      console.log("OD_VIS_D: " + this.visionInfo.diagnosesOD[0])
      console.log("OD_VIS_R: " + this.visionInfo.recommendOD[0])
    },
    updateFinding_OS(f, d, r) {
      this.visionInfo.findingsOS.push(f)
      this.visionInfo.diagnosesOS.push(d)
      this.visionInfo.recommendOS.push(r)
      console.log("OS_VIS_F: " + this.visionInfo.findingsOS[0])
      console.log("OS_VIS_D: " + this.visionInfo.diagnosesOS[0])
      console.log("OS_VIS_R: " + this.visionInfo.recommendOS[0])
    },
    updateFinding_OU(f, d, r) {
      this.visionInfo.findingsOU.push(f)
      this.visionInfo.diagnosesOU.push(d)
      this.visionInfo.recommendOU.push(r)
      console.log("OU_VIS_F: " + this.visionInfo.findingsOU[0])
      console.log("OU_VIS_D: " + this.visionInfo.diagnosesOU[0])
      console.log("OU_VIS_R: " + this.visionInfo.recommendOU[0])
    }
  }
}
</script>

<style lang="scss" scoped>
#vision {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.md-field {
  margin: 0px 0px 0px 0px;
  padding-top: 5px;
}

.label {
  font-size: 0.75rem;
  font-weight: 500;
}

.field {
  font-size: 0.95rem;
  font-weight: 500;
  color: rgb(0, 0, 139);
  padding-left: 50px;
}

.field2 {
  font-size: 0.95rem;
  font-weight: 500;
  color: rgb(0, 0, 139);
}

.lbl1 {
  color: green;
  margin-top: 10px;
  font-size: 0.9rem;
  font-weight: 500;
}

.lbl2 {
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 300;
}
</style>
